import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {AuthControllerService} from '../services/auth-controller/auth-controller.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class GetLoginUrlService {
	currentLang: string;

    constructor(private authService: AuthControllerService, private translate: TranslateService) {
		this.authService = authService;
		this.translate = translate;
    }
	
	get loginUrl() {
		return environment.authUrl + 'cas/spa.html#/?response_type=code&client_id=' + environment.OAuthClientId + '&state=' + this.authService.randomId() + '&scope=any&redirect_uri=' + environment.OAuthRedirectUrl + '&lang=' + this.translate.currentLang;
	}

}
